exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".sidebar,.sidebar-button{display:none}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/sidebar/SidebarStandard1/src/components/sidebar/SidebarStandard1/SidebarStandard1.m.scss"],"names":[],"mappings":"AAIE,yBACE,YAAa,CACd","file":"SidebarStandard1.m.scss","sourcesContent":["@import '~scss/variables';\n\n.sidebar {\n  display: none;\n  &-button {\n    display: none;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/sidebar/SidebarStandard1/SidebarStandard1.m.scss
// module id = 1266
// module chunks = 54